export enum TRANSFER_TYPES {
  LINK = 'link',
  EMAIL = 'email',
  PROJECT = 'project',
}

export enum TransferTypeId {
  LINK = 4,
  EMAIL = 1,
}

// Map of transfer types IDs from the DB
export const TRANSFER_TYPES_IDS: {
  [key in TransferTypeId]: TRANSFER_TYPES;
} = {
  [TransferTypeId.LINK]: TRANSFER_TYPES.LINK,
  [TransferTypeId.EMAIL]: TRANSFER_TYPES.EMAIL,
};
